var lx = lx || {};

/* created on: 20.10.2017 by: Davor
*  updated on: ...
* include files:
* - /i/social/js/lxpMultirow.js?v=&&APP_RELEASE_VERSION.
* - /i/social/css/lxpMultirow.css?v=&&APP_RELEASE_VERSION.
* add this if slide in effect is used:
* - /i/libraries/jquery-ui/1.10.4/ui/jquery.ui.effect-slide.js
*
* Example: lx.multirow.init({code:"PROJECT_HR",params:["13896","H"]});
*/
lx.multirow = {
    data: {},
    html: null,
    code: "PROJECT_HR",
    params: [],
    page: 1,
    search: "",
    searchCol: 1,
    slideSpeed: 500,
    change: [],
    delete: [],
    updated: false,
    formChange: false,
    opened: false,
    selectA: [],
    mainSelector: null,
    init: function (params) {
        this.code = params.code;
        this.params = params.params;
        if (params.e) e.stopPropagation();
        this.loadData();
        this.updated = false;
        this.formChange = false;
    },
    loadData: function (pDataOnly) {
        var self = this, vDataOnly = "N";
        if (pDataOnly) vDataOnly = "Y";
        lx.load.add();
        $.ajax({
            url: "wwv_flow.show",
            dataType: "json",
            traditional: true,
            cache: false,
            type: "POST",
            data: {
                p_flow_id: $v("pFlowId"),
                p_flow_step_id: $v("pFlowStepId"),
                p_instance: $v("pInstance"),
                p_request: "APPLICATION_PROCESS=multirow",
                x01: self.code,
                x02: self.page,
                x03: self.params.join(":"),
                x04: self.search,
                x05: self.searchCol,
                x06: vDataOnly
            },
            success: function (d) {
                lx.load.remove();
                if (d.ERR) alert(d.ERR);
                else {
                    if (pDataOnly) {
                        self.data.rows = d.rows;
                        self.data.records = d.records;
                        if (d.info) self.data.gen.info = d.info;
                        if (d.filterPic) self.data.gen.filterPic = d.filterPic;
                    }
                    else self.data = d;
                    self.open();
                }
            }
        });
    },
    refresh: function () {
        if ((this.change.length > 0 || this.delete.length > 0) && confirm(lx.tran.get('APPLY_CHANGES') + '?')) this.submit();
        else {
            this.loadData(true);
            this.change = [];
        }
    },
    genPagination: function () {
        var records = this.data.records, recPerPage = this.data.recPerPage, pages = Math.ceil(records / recPerPage);
        var min = 1, max = pages, buffer = 10;
        var pagination = '';
        if (this.page != 1) pagination += '<span onclick="multirowForm.setPage(1)" title="First Page"><<</span>'
            + '<span onclick="multirowForm.setPage(' + (this.page - 1) + ')" title="Previous Page"><</span>';
        if (this.page > buffer && this.page < (this.data.gen)) {
            min = this.page - buffer;
            max = this.page + buffer;
        } else if (this.page <= buffer && pages > (2 * buffer)) max = 2 * buffer;
        else if (this.page >= (pages - buffer) && pages > (2 * buffer)) min = pages - (2 * buffer);

        for (var i = min; i <= max; i++) {
            if (i == this.page) pagination += '<span class="lxIrCurrentPg">' + i + '</span>';
            else pagination += '<span onclick="multirowForm.setPage(' + i + ');">' + i + '</span>';
        }
        if (this.page != pages) pagination += '<span onclick="multirowForm.setPage(' + (this.page + 1) + ')" title="' + lx.tran.get('NEXT_PAGE') + '">></span>'
            + '<span onclick="multirowForm.setPage(' + pages + ')" title="' + lx.tran.get('LAST_PAGE') + '">>></span>';
        pagination = '<div class="lxIrPagination">' + lx.tran.get('PAGE') + ':&nbsp;&nbsp;' + pagination + ' | ' +  lx.tran.get('TOTAL_RECORDS') + ': ' + records + '</div>';
        return pagination;
    },
    setPage: function (params) {
        this.page = params;
        this.refresh();
    },
    setParam: function (params) {
        //this.params[params.index] = params.value;
        var $vItem = $(params), paramIndex = $vItem.closest(".mrFilter").attr("param");
        this.params[paramIndex] = $vItem.val();
        this.refresh();
    },
    open: function () {
        var self = this;
        var formHtml = '', filter = '', vInfo = '', lxForm = '', tblLegend = '', rows = [];
        // Columns
        for (var i = 0; i < self.data.col.length; i++) {
            if (self.data.col[i].name/*type != 'H'*/ && self.data.col[i].type != 'ID' && self.data.col[i].type != 'CLASS')
                formHtml += ( self.data.gen.rotateHdrs  ? '<th class="rotate"><div><span>' + self.data.col[i].name + '</span></div></th>' 
                                                    : '<th>' + self.data.col[i].name + '</th>' );
        }
        // Filters
        if (self.data.gen.filters) {
            var vOptions;
            for (var i = 0; i < self.data.gen.filters.length; i++) {
                if (self.data.gen.filters[i].type == "T") {
                    filter += '<div class="mrFilter" param="' + self.data.gen.filters[i].param + '"><div class="name">'
                        /*+ self.data.gen.filters[i].name */
                        + '</div><div class="options"><input type="text"  placeholder="Search: Contacts"'
                        + 'style="width:200px;" onchange="multirowForm.setParam(this);" value="'
                        + self.params[self.data.gen.filters[i].param] + '" />'
                        + '<div class="lxMultiSearchBtn">Go</div>'
                        + '</div></div>';
                } else {
                    vOptions = "";
                    for (var j = 0; j < self.data.gen.filters[i].options.length; j++) {
                        vOptions += '<option value="' + self.data.gen.filters[i].options[j].r
                            + '"' + ((self.params[self.data.gen.filters[i].param] == self.data.gen.filters[i].options[j].r) ? ' selected' : '')
                            + '>' + self.data.gen.filters[i].options[j].d + '</option>';
                    }
                    filter += '<div class="mrFilter" param="' + self.data.gen.filters[i].param + '"><div class="name">'
                        + self.data.gen.filters[i].name + '</div><div class="options"><select onchange="multirowForm.setParam(this);">'
                        + vOptions + '</select>'
                        + ((self.data.gen.filters[i].picture) ? self.data.gen.filterPic[self.data.gen.filters[i].picture] : '')
                        + '</div></div>';
                }
            }
        }
        // Info
        if (self.data.gen.info.length && self.data.gen.info.length > 0) {
            for (var i = 0; i < self.data.gen.info.length; i++) {
                vInfo += '<div>' + self.data.gen.info[i].name + ' '
                    + self.data.gen.info[i].value + '</div>';
            }
            if (vInfo) vInfo = '<div class="mrInfo">' + vInfo + '</div>';
        }
        // Lx Form
        if (self.data.gen.form) {
            for (var i = 0; i < self.data.gen.form.item.length; i++) {
               /* if (self.data.gen.form.item[i].newRow == 'Y') lxForm += '<br>';*/
                lxForm += lx.item.gen({ "id": 'lxForm' + i, "item": self.data.gen.form.item[i], "data": self.data.gen.formData[i], "classResp": 'col col-'+ (self.data.gen.form.item[i].colSpan ? self.data.gen.form.item[i].colSpan : '12') +' apex-col-auto mrItem'});
            }
            lxForm = '<div id="' + self.data.gen.form.id + '" class="col col-12 apex-col-auto lxForm" onchange="multirowForm.formChange = true;">' + lxForm + '</div>';
        }
        // Legend
        if (self.code == "PROJECT_HR")
            tblLegend = '<div class="lxMrLegend"><div class="attend-P"></div> Verfied <div class="attend-N"></div> Rejected </div>';
        else if (self.code == "CERT" || self.code == "CERT_TEMP")
            tblLegend = '<div class="lxMrLegend"><div class="attend-E"></div> Expiring <div class="attend-N"></div> Expired </div>';
        // generate rows
        if (self.data.rows.length > 0)
            for (var i = 0; i < self.data.rows.length; i++)
                rows.push(self.addRow(self.data.rows[i].row));
        // multirow form
		if (self.data.gen.open == "popUp") {
            formHtml = '<div><div class="lxpMultirow"' + ((this.data.gen.width) ? ' style="max-width:' + (this.data.gen.width - 30) + 'px;margin: 1.6rem;"' : '')
				+ '>'
				+ '<div class="cont">' + vInfo + filter + lxForm
				+ '<div>' + tblLegend
				+ '<table><thead><tr>'
				+ formHtml
				+ '</tr></thead><tbody>'
				+ rows.join("") + '</tbody></table></div>'
				+ self.genPagination()
				+ '</div></div>'
				+ '<div class="mrBtnFooter"><div style="flex: auto;">'
				+ ((self.data.gen.open == "slideIn" || self.data.gen.open == "popUp") ? 
					'</div><div>'+ lx.btn.gen({"label":lx.tran.get('BACK'),"fa":"fas fawe-long-arrow-alt-left","js":"multirowForm.close();"})/*'<div class="lxBtn" onclick="multirowForm.close();">Close</div>'*/ 
					: '')
				+ (self.data.gen.updateOnly ? '' : lx.btn.gen({"label":(self.data.gen.addLabel ? self.data.gen.addLabel : lx.tran.get('ADD') ),"fa":"fas fawe-plus","js":"multirowForm.addRow();"})/*'<div class="lxBtn hot" onclick="multirowForm.addRow();">Add Row</div>'*/)
				+ lx.btn.gen({"label":lx.tran.get('APPLY_CHANGES'),"fa":"fas fawe-save","js":"multirowForm.submit();","class":"t-Button--primary"})//'<div class="lxBtn hot mrSave" onclick="multirowForm.submit();">Apply Changes</div>'
				+ '</div></div>';
				+ '</div>';
		} else if (self.data.gen.open == "drawer") {
            formHtml = /*'<div class="t-Drawer-page t-PageTemplate--drawer js-dialog-class-t-Drawer--pullOutEnd apex-side-nav apex-icons-fontapex apex-theme-linxpot-theme js-dialogReady">'
                +*/'<div class="t-Drawer" role="dialog" style="height:100%"><div class="t-Drawer-header"></div><div class="t-Drawer-bodyWrapperOut"><div class="t-Drawer-bodyWrapperIn"><div class="t-Drawer-body" role="main">'
                +'<div class="lxpMultirow"' + ((this.data.gen.width) ? ' style="max-width:' + (this.data.gen.width - 30) + 'px;margin: 1.6rem;"' : '')
				+ '>'
				+ '<div class="cont">' + vInfo + filter + lxForm
				+ '<div>' + tblLegend
				+ '<table><thead><tr>'
				+ formHtml
				+ '</tr></thead><tbody>'
				+ rows.join("") + '</tbody></table></div>'
				+ self.genPagination()
				+ '</div></div>'
				+ '<div class="mrBtnFooter"><div style="flex: auto;">'
				+ '</div></div>'
				+ '</div></div></div>'// drawer body
                + '<div class="t-Drawer-footer"><div class="t-ButtonRegion t-Form--floatLeft lto4315632330375998_0" id="R4315632330375998" role="region" aria-label="&nbsp;"><div class="t-ButtonRegion-wrap">'
                + '<div class="t-ButtonRegion-col t-ButtonRegion-col--left"></div>'
                + '<div class="t-ButtonRegion-col t-ButtonRegion-col--content"></div>'
                + '<div class="t-ButtonRegion-col t-ButtonRegion-col--right"><div class="t-ButtonRegion-buttons">'
				+ (self.data.gen.addBulkLabel ? lx.btn.gen({"label": self.data.gen.addBulkLabel,"fa":"fas fawe-calendar-plus","link":self.data.gen.addBulkLink}) : '')
				+ (self.data.gen.updateOnly ? '' : lx.btn.gen({"label":(self.data.gen.addLabel ? self.data.gen.addLabel : lx.tran.get('ADD') ),"fa":"fas fawe-plus","js":"multirowForm.addRow();"})/*'<div class="lxBtn hot" onclick="multirowForm.addRow();">Add Row</div>'*/)
				+ lx.btn.gen({"label":lx.tran.get('APPLY_CHANGES'),"fa":"fas fawe-save","js":"multirowForm.submit();","class":"t-Button--primary"})//'<div class="lxBtn hot mrSave" onclick="multirowForm.submit();">Apply Changes</div>'
                + lx.btn.gen({"label":lx.tran.get('CLOSE'),"fa":"far fawe-times","js":"lx.drawer.close(this);"})
                + '</div></div>'
				+ '</div></div></div>'// drawer buttons
				+ '</div>'
				/*+ '</div>'*/;
		} else {
			formHtml = '<div class="lxpMultirow"' + ((this.data.gen.width) ? ' style="max-width:' + (this.data.gen.width - 30) + 'px;margin-left:auto;margin-right:auto"' : '')
				+ '>'
				+ '<div class="hdr"><div style="flex: auto;">' + this.data.gen.title
				+ ((self.data.gen.open == "slideIn" || self.data.gen.open == "popUp") ? 
					'</div><div>'+ lx.btn.gen({"label":lx.tran.get('BACK'),"fa":"fas fawe-long-arrow-alt-left","js":"multirowForm.close();"})/*'<div class="lxBtn" onclick="multirowForm.close();">Close</div>'*/ 
					: '')
				+ (self.data.gen.updateOnly ? '' : lx.btn.gen({"label":(self.data.gen.addLabel ? self.data.gen.addLabel : lx.tran.get('ADD') ),"fa":"fas fawe-plus","js":"multirowForm.addRow();"})/*'<div class="lxBtn hot" onclick="multirowForm.addRow();">Add Row</div>'*/)
				+ lx.btn.gen({"label":lx.tran.get('APPLY_CHANGES'),"fa":"fas fawe-save","js":"multirowForm.submit();","class":"t-Button--primary"})//'<div class="lxBtn hot mrSave" onclick="multirowForm.submit();">Apply Changes</div>'
				+ '</div></div>'
				+ '<div class="cont">' + vInfo + filter + lxForm
				+ '<div>' + tblLegend
				+ '<table><thead><tr>'
				+ formHtml
				+ '</tr></thead><tbody>'
				+ rows.join("") + '</tbody></table></div>'
				+ self.genPagination()
				+ '</div>'
				+ '</div>';
			}	
        self.html = formHtml;
        //alert(1);
        if (self.data.gen.open == "slideIn") self.slideIn();
        else if (self.data.gen.open == "popUp") self.openPopup();
        else if (self.data.gen.open == 'drawer') self.drawer();
        else $("#" + self.data.gen.open).html(formHtml);
        //alert(2);
        self.opened = true;

        self.selectA = [];
        for (var i = 0; i < this.data.col.length; i++) {
            if (this.data.col[i].type == "SA" || this.data.col[i].type == "SMA") {
                self.selectA.push({ "name": this.data.col[i].id });
            }
        }
        self.jsItemInit();
    },
    close: function () {
        var self = this;
        if ((this.change.length > 0 || this.delete.length > 0 || this.formChange) && confirm(lx.tran.get('SUBMIT_CHANGES') + '?'))
            this.submit(true);
        else {
            this.change = [];
            this.delete = [];
            this.formChange = false;
            if (self.data.gen.open == "slideIn") self.slideOut();
            else if (self.data.gen.open == "popUp") self.closePopup();
            else if (self.data.gen.open == 'drawer') lx.drawer.close();
            else $("#" + self.data.gen.open).html();
            if (self.updated) self.refreshCallback();
            self.opened = false;
            apex.message.clearErrors();
            $x_Remove('uSuccessMessage');
        }
    },
    getMainSelector: function () {
        if ($('#main').length == 1) lx.multirow.mainSelector = '#main';
        else if ($('.t-Dialog').length == 1) lx.multirow.mainSelector = '.t-Dialog';
        else if ($('.t-Drawer').length == 1) lx.multirow.mainSelector = '.t-Drawer';
        else lx.info.alert("No Main Selector!");
        // onclick="lx.info.alert($('#main').length);"
    },
    drawer: function () {
        var self = this;
        lx.drawer.open(self.data.gen.title, self.html);
    },
    slideIn: function () {
        var self = this;
        if (!self.opened) {
            self.getMainSelector();
            // if closed open the form
            $('<div class="lxpMultirowSlide" style="display:none;">' + self.html + '</div>').insertAfter(self.mainSelector);
            //if (self.mainSelector == '.t-Dialog') {
                $(self.mainSelector).hide();
                $(".lxpMultirowSlide").show();
            /*} else {
                $(self.mainSelector).hide("slide", { direction: "left" }, self.slideSpeed, function () {
                    $(".lxpMultirowSlide").show("slide", { direction: "right" }, self.slideSpeed);
                    //$('html, body').animate({scrollTop: $(".lxBtn" + searchProfileType).offset().top - 70}, 10);
                });
            }*/
            $(".t-BreadcrumbRegion-buttons").hide();
        } else $(".lxpMultirow").replaceWith(self.html); // already open just replace content
    },
    slideOut: function () {
        var self = this;
        //if (self.mainSelector == '.t-Dialog') {
            $(".lxpMultirowSlide").hide();
            $(self.mainSelector).show();
            $(".lxpMultirowSlide").remove();
            $(".t-BreadcrumbRegion-buttons").show();
        /*} else {
            // hide multirow and show main
            $(".lxpMultirowSlide").hide("slide", { direction: "right" }, self.slideSpeed, function () {
                $(self.mainSelector).show("slide", { direction: "left" }, self.slideSpeed);
                $(".lxpMultirowSlide").remove();
                $(".t-BreadcrumbRegion-buttons").show();
            });
        }*/
    },
    openPopup: function () {
        var self = this;
        if (!self.opened) {
            $('<div class="lxpMultirowPopup">' + this.html + '</div>').dialog({
                modal: true,
                resizable: true,
                //resize: "auto",
                height: "auto",
                minHeight: 500,
                title: this.data.gen.title,
                width: self.data.gen.width,
                close: function (event, ui) {
                    self.close();
                }
            });
        } else $(".lxpMultirowPopup").html(self.html); // already open just replace content
        // fix for select2 search
        $.ui.dialog.prototype._allowInteraction = function (e) { return true; };
    },
    closePopup: function () {
        $(".lxpMultirowPopup").dialog("destroy");
    },
    addRow: function (params) {
        var vRet = "", vTemp, vHidden = "", vData = false, vValue, vDate = false, vSelect = false, vSelectA, vCascade, vRowClass = '', vWidth, vType, vAloIdType = '', v_type_temp = '';
        
        if (params) vData = true;
		if (this.code == 'CERT_TEMP' && vData){vAloIdType = params[3].r;}
		//alert("vAloIdType="+vAloIdType);
        // iterate items
        for (var i = 0; i < this.data.col.length; i++) {
            vTemp = "";
            var vTdClass = "";
            // set item value
            if (this.data.col[i].type != 'DEL')
                if (vData) {vValue = params[i].r;}
                else {vValue = (this.data.col[i].def == 'PARAM') ? this.params[this.data.col[i].defParam] : this.data.col[i].def;}
            // set item width if specified
            if (this.data.col[i].width) vWidth = 'width:' + this.data.col[i].width + ';';
            else vWidth = '';
            // check row modifier for item type
            if (vData && this.data.col[i].type != 'DEL') {
                if (typeof params[i].mod === 'undefined' || params[i].mod == null) v_type = this.data.col[i].type;//
                else if (params[i].mod == "H") v_type = "E";
                else v_type = this.data.col[i].type;
            } else {
                v_type = this.data.col[i].type;
            }
			// Following if statement is CERT_TEMP related
			if (vAloIdType == 337) {
				v_type_temp = this.data.col[i].type;
				if (v_type_temp == 'S') {v_type = 'DL';}
				if (v_type_temp == 'T') {v_type = 'DO';}
				if (v_type_temp == 'D') {v_type = 'DO';}
				//if (v_type_temp == 'DEL') {v_type = 'REM';}
				//alert(v_type_temp+"-"+v_type+"-"+this.data.col[i].id+"-"+params[i].d);				
			}
            // generate item based on his type
            switch (v_type) {
                // Hidden item
                case "H": 
                    if (this.data.col[i].disp) vTemp += '<input type="hidden" name="' + this.data.col[i].id + '" value="' + vValue + '" />'
                                                     + '<span>'+ ((vData) ? params[i].d : this.data.col[i].disp) +'</span>';
                    else vHidden += '<input type="hidden" name="' + this.data.col[i].id + '" value="' + vValue + '" />';
                    break;
                // Hidden item
                case "E": vTemp += '<input type="hidden" name="' + this.data.col[i].id + '" value="' + vValue + '" />';
                    break;
                // Number item
                case "N": vTemp = '<input type="text" name="' + this.data.col[i].id + '" value="' + vValue + '" style="text-align:right;' + vWidth + '" />';
                    break;
                // Text item
                case "T": vTemp = '<input type="text" name="' + this.data.col[i].id + '" value="' + vValue + '"' + (vWidth ? ' style="' + vWidth + '"' : '') + ' />';
                    break;
                // Text area item
                case "TA": vTemp = '<textarea rows="1" name="' + this.data.col[i].id + '" style="height:20px;' + vWidth
                    + '">' + vValue + '</textarea>';
                    break;
                // Date Item
                case "D": vTemp = '<input type="text" name="' + this.data.col[i].id + '" value="' + vValue + '" class="lxpMrDate" data-format="'+ this.data.col[i].dateFormat +'" />';
                    vDate = true;
                    break;
                // Minutes of day
                case "MD": vTemp = '<input type="hidden" name="' + this.data.col[i].id + '" value="' + vValue + '" />';
                    var vHrs = Math.floor(vValue / 60);
                    var vMin = vValue % 60;
                    if (vValue == '') {vHrs = null; vMin = null;}
                    // Hour selectbox
                    vTemp += '<select name="lxpItemMD_H" style="width:60px;padding:1px;" class="lxpMrSelect"><option value="">-</option>';
                    for (var k = 0; k < 24; k++) {
                        var vH = k;
                        if (k == 0) vH = 12;
                        else if (k > 12) vH = k - 12;
                        if (k < 12) vH = vH + ' AM';
                        else vH = vH + ' PM';
                        vTemp += '<option value="'+ k + '"'+ (k == vHrs ? ' selected' : '') + '>'+ vH +'</option>';
                    }
                    // Duration calculation and midnight option
                    if (this.data.col[i].options){
                        if ((this.data.col[i].options.from || this.data.col[i].options.to) && typeof this.calcDuration == 'undefined') this.calcDuration = {};
                        if (this.data.col[i].options.from) this.calcDuration.from = this.data.col[i].id;
                        if (this.data.col[i].options.to) this.calcDuration.to = this.data.col[i].id;
                        if (this.data.col[i].options.hrs) this.calcDuration.hrs = this.data.col[i].options.hrs;
                        if (this.data.col[i].options.min) this.calcDuration.min = this.data.col[i].options.min;
                        if ( this.data.col[i].options.midnight) vTemp += '<option value="24"'+ (24 == vHrs ? ' selected' : '') + '>12 AM</option>';
                    }
                    // minute selectbox
                    vTemp += '</select><select name="lxpItemMD_M" style="width:40px;padding:1px;" class="lxpMrSelect"><option value="">-</option>';
                    for (let j = 0; j < 60; j++) {
                        vTemp += '<option value="'+ j + '"'+ (j == vMin ? ' selected' : '') + '>'+ ("0" + j).substr(-2,2) +'</option>';
                    }
                    vTemp += '</select>';
                    vTemp = '<div class="lxpItemMD" onchange="lxpItemMD(this);" style="width: 100px;">'+ vTemp +'</div>';
                    break;
                // Select item
                case "S": var vSelected = false;
                    for (var o = 0; o < this.data.col[i].options.length; o++) {
                        if (vValue == this.data.col[i].options[o].r) {
                            vSelected = true;
                            vTemp += '<option value="' + this.data.col[i].options[o].r + '" selected >'
                                + this.data.col[i].options[o].d + '</option>';
                        } else vTemp += '<option value="' + this.data.col[i].options[o].r + '">'
                            + this.data.col[i].options[o].d + '</option>';
                    }
                    if (vData && typeof vValue != 'undefined' && !vSelected) vTemp += '<option value="' + vValue + '" selected>' + params[i].d + '</option>';

                    if (this.data.col[i].feat == "PROF_PIC") vTemp = '<div class="lxpMrPic"><img src="LINXPOT.multimedia.thumb?p_id='
                        + (vData ? params[i].r : this.data.col[i].def)
                        + '&p_maxscale=45 45&p_type=PROFILE_EMP&p_rec_id=' + this.data.gen.owner
                        + '" /></div><select class="lxpSelectBox" name="' + this.data.col[i].id
                        + '" ' + (vWidth ? ' style="' + vWidth + '"' : '') + ' onchange="multirowForm.featSelect(this);">'
                        + vTemp + '</select>';
                    else if (this.data.col[i].feat == "PIC") vTemp = '<div class="lxpMrPic">'
                        + (vData ? params[i].pic : '')
                        + '</div><select name="' + this.data.col[i].id
                        + '" ' + (vWidth ? ' style="' + vWidth + '"' : '') + '>'
                        + vTemp + '</select>';
                    else vTemp = '<select class="lxpMrSelect" name="' + this.data.col[i].id + '"' + (vWidth ? ' style="' + vWidth + '"' : '') + '>' + vTemp
                        + '</select>';
                    vSelect = true;
                    break;
                // Select AJAX item
                case "SA": if (vValue) vTemp = '<option value="' + vValue + '" selected>' + ((vData) ? params[i].d : this.data.col[i].defText) + '</option>';

                    vTemp = '<select class="lxpMrSelectA" name="' + this.data.col[i].id + '"' + (vWidth ? ' style="' + vWidth + '"' : '') + ' ajax="'
                        + this.data.col[i].ajaxCode + '" cascade="'
                        + this.data.col[i].cascade + '">' + vTemp + '</select>';
                    /*vSelectA = this.data.col[i].ajaxCode;
                    vCascade = this.data.col[i].cascade;*/
                    break;
                // Select item
                case "SM": var vSelected;
                    for (var o = 0; o < this.data.col[i].options.length; o++) {
                        vSelected = false;
                        for (var v = 0; v < vValue.length; v++) {
                            if (vValue[v] == this.data.col[i].options[o].r)
                                vSelected = true;
                        }alert(vValue[v] );
                        vTemp += '<option value="' + this.data.col[i].options[o].r + '"'
                            + (vSelected ? ' selected' : '') + '>'
                            + this.data.col[i].options[o].d + '</option>';

                    }
                    vTemp = '<select class="lxpMrSelect" name="' + this.data.col[i].id + '"' + (vWidth ? ' style="' + vWidth + '"' : '') + ' multiple="multiple">' + vTemp
                        + '</select>';
                    vSelect = true;
                    break;
                // Select multiple AJAX item
                case "SMA": if (vValue)
                    for (var v = 0; v < vValue.length; v++) {
                        if (vValue[v])
                            vTemp += '<option value="' + vValue[v] + '" selected>' + ((vData) ? params[i].d[v] : this.data.col[i].defText) + '</option>';
                    }

                    vTemp = '<select class="lxpMrSelectA" name="' + this.data.col[i].id + '"' + (vWidth ? ' style="' + vWidth + '"' : '') + ' multiple="multiple" ajax="'
                        + this.data.col[i].ajaxCode + '" cascade="'
                        + this.data.col[i].cascade + '">' + vTemp + '</select>';
                    /*vSelectA = this.data.col[i].ajaxCode;
                    vCascade = this.data.col[i].cascade;*/
                    break;
                // Checkbox item
                case "C": vTemp = '<input type="checkbox" name="' + this.data.col[i].id + '" value="' + this.data.col[i].options[0].r
                    + '"' + ((this.data.col[i].options[0].r == vValue) ? ' checked="checked"' : '')
                    + '" />';
                    break;
                // custom lxp Row Radio item only one row can be selected
                case "RR": vTemp = '<input type="radio" name="' + this.data.col[i].id + '" value="' + this.data.col[i].options[0].r
                    + '"' + ((this.data.col[i].options[0].r == vValue) ? ' checked="checked"' : '')
                    + '" />';
                    break;
                // Display only
                case "DO": vTemp = '<span class="displayOnly" name="' + this.data.col[i].id + '">' + vValue/*this.data.col[i].options[0].r*/ + '</span>';
                    break;
                // Display LOV only
                case "DL": for (var o = 0; o < this.data.col[i].options.length; o++) {
                    if (this.data.col[i].options[o].r == vValue) vTemp = this.data.col[i].options[o].d;
                }
					if (this.data.col[i].feat == "PIC") {
						vTemp = '<div class="lxpMrPic">' + (vData ? params[i].pic : '') + '</div><span class="displayOnly" name="' + this.data.col[i].id + '" value="' + vValue + '">' + vTemp + '</span>'
					}
					else {
						vTemp = '<span class="displayOnly" name="' + this.data.col[i].id + '" value="' + vValue + '">' + vTemp + '</span>';
					}
                    break;				
                // custom lxp radio item
                case "RC": for (var o = 0; o < this.data.col[i].options.length; o++) {
                    vTemp += '<div value="' + this.data.col[i].options[o].r + '" class="' + this.data.col[i].options[o].c
                        + ((vValue == this.data.col[i].options[o].r) ? ' active' : '')
                        + '" onclick="lxSelectBox(this);"><span>' + this.data.col[i].options[o].d + '</span><span>' + this.data.col[i].options[o].a + '</span></div>';
                }
                    vTemp = '<div name="' + this.data.col[i].id + '" class="lxSelectBox">' + vTemp + '</div>';
                    break;
                // row class
                case "CLASS": vRowClass = ' class="' + vValue + '"';
                    break;
                // delete row item
                case "DEL": vTemp = '<div class="lxMrDelete" onclick="multirowForm.delRow(this);"><i class="fas fawe-trash-alt" style="font-size: 14px;'
                    + '"></i></div>';
                    vTdClass = 'lxMrTdDelete';
                    break;
                //  flag as deleted row item
                /*case "REM": vTemp = '<div class="lxMrDelete" onclick="multirowForm.remRow(this);"><i class="fas fawe-trash-alt" style="font-size: 14px;'
                        + '"></i></div>';
                        break;*/
                default: null;
            }
			// Following if statement is CERT_TEMP related
			if (vAloIdType == 337) {			
				v_type = v_type_temp;
			}
            if (vTemp != "") {
                vRet += '<td'+ (vTdClass != '' ? ' class="'+vTdClass+'"' : '') +'>' + vTemp + vHidden + '</td>';
                vHidden = "";
            }

        }

        if (vData) {
            return '<tr rowid="' + (vData ? params[0].r : this.data.col[0].def - this.change.length) + '" onchange="multirowForm.rowChange(this);"' + vRowClass + '>' + vRet + '</tr>';
        } else {
            $(".lxpMultirow table > tbody").prepend('<tr rowid="' + (vData ? params[0].r : this.data.col[0].def - this.change.length) + '" onchange="multirowForm.rowChange(this);"' + vRowClass + '>' + vRet + '</tr>');
            this.jsItemInit({ "new": true });
            this.rowChange($(".lxpMultirow table > tbody tr:first-child"));
        }
    },
    jsItemInit: function (params) {
        var self = this;
        var vSelector = '';
        if (params) {
            vSelector = ' table > tbody tr:first-child'
        }
        $(".lxpMultirow" + vSelector + " input.lxpMrDate").each( (index, i) => {
            console.log(i);
            console.log(i.getAttribute("data-format"));
            $(i).datepicker({dateFormat: i.getAttribute("data-format")})
        });//.datepicker({ dateFormat: translation.date_format });
        //$(".lxpMultirow"+ vSelector +" select.lxpMrSelect").select2();
        if (self.selectA)
            for (var i = 0; i < self.selectA.length; i++) {
                $(".lxpMultirow" + vSelector + " select.lxpMrSelectA[name=" + self.selectA[i].name + "]").select2({
                    width: 'resolve',
                    ajax: {
                        url: "wwv_flow.show",
                        dataType: "json",
                        traditional: true,
                        cache: false,
                        data: function (params) {
                            return {
                                p_flow_id: $v("pFlowId"),
                                p_flow_step_id: $v("pFlowStepId"),
                                p_instance: $v("pInstance"),
                                p_request: "APPLICATION_PROCESS=multirowLov",
                                x01: $(this).attr("ajax"),
                                x02: params.term,
                                x03: $(this).closest("tr").find("[name=" + $(this).attr("cascade") + "]").val(),
                                x04: 1,
                                x05: i
                            }
                        }
                    }
                });
            }
        // resize modal dialog
        //console.log("resizing window tooo: "+ $('body').height())
        if (window.top.url != window.url) setTimeout(function () {window.parent.lx.iframe.Height($('body').height());}, 200);
    },
    featSelect: function (params) {
        var vValue = $(params).val();
        $(params).siblings("img").attr("src", "LINXPOT.multimedia.thumb?p_id=" + vValue + "&p_maxscale=45 45&p_type=PROFILE_EMP&p_rec_id=" + this.data.gen.owner);
    },
    rowChange: function (params) {
        var rowData = [],
            $row = $(params),
            pushRow = true;

        rowData.push($row.attr("rowid"));
        for (var i = 0; i < this.data.col.length; i++) {
            switch (this.data.col[i].type) {
                case "H": rowData.push($row.find('input[name=' + this.data.col[i].id + ']').val().replace("|", "").replace("~", ""));
                    break;
                case "N": rowData.push($row.find('input[name=' + this.data.col[i].id + ']').val().replace("|", "").replace("~", ""));
                    break;
                case "T": rowData.push($row.find('input[name=' + this.data.col[i].id + ']').val().replace("|", "").replace("~", ""));
                    break;
                case "TA": rowData.push($row.find('textarea[name=' + this.data.col[i].id + ']').val().replace("|", "").replace("~", ""));
                    break;
                case "D": rowData.push($row.find('input[name=' + this.data.col[i].id + ']').val());
                    break;
                case "MD": rowData.push($row.find('input[name=' + this.data.col[i].id + ']').val());
                    break;
                case "S": rowData.push($row.find('select[name=' + this.data.col[i].id + ']').val());
                    break;
                case "SA": rowData.push($row.find('select[name=' + this.data.col[i].id + ']').val());
                    break;
                case "SM": rowData.push($row.find('select[name=' + this.data.col[i].id + ']').select2("val").join(":"));
                    break;
                case "SMA": try {
                    rowData.push($row.find('select[name=' + this.data.col[i].id + ']').select2("val").join(":"));
                } catch (err) {
                    rowData.push($row.find('select[name=' + this.data.col[i].id + ']').val());
                }
                    break;
                case "C": rowData.push($row.find('input[name=' + this.data.col[i].id + ']:checked').val());
                    break;
                case "RR": rowData.push($row.find('input[name=' + this.data.col[i].id + ']:checked').val());
                    break;
                case "DL": rowData.push($row.find('span[name=' + this.data.col[i].id + ']').attr("value"));
                    break;
                case "RC": rowData.push($row.find('.lxSelectBox[name=' + this.data.col[i].id + '] > .active').attr("value"));
                    break;
                default: null;
            }
        }

        for (var j = 0; j < this.change.length; j++) {
            if (this.change[j][0] == rowData[0]) {
                this.change[j] = rowData;
                pushRow = false;
            }
        }

        if (pushRow) this.change.push(rowData);

        $(".mrSave").addClass("red");
    },
    delRow: function (params) {
        var $row = $(params).closest("tr"),
            rowid = $row.attr("rowid");
        this.delete.push(rowid);
        $row.remove();

        for (var j = 0; j < this.change.length; j++) {
            if (this.change[j][0] == rowid) this.change.splice(j, 1);
        }

        $(".mrSave").addClass("red");
    },
    remRow: function (params) {
        var $row = $(params).closest("tr"),
            rowid = $row.attr("rowid");
        this.delete.push(rowid);
        $row.remove();

        for (var j = 0; j < this.change.length; j++) {
            if (this.change[j][0] == rowid) this.change.splice(j, 1);
        }

        $(".mrSave").addClass("red");
    },
    refreshCallback: function () {
        //alert(this.code);
        var self = this;
        if (self.code == 'PROJECT_HR') {
            if ($("#gantt_container").length == 1) {
                //alert(self.params[0]);
                setTimeout(function () { refreshTask(self.params[0]); }, self.slideSpeed);
            } else {
                lxTaskList(self.data.gen.projectId, self.params[0]);
                //lxTaskInfo(self.params[0]);
            }
        } else if (self.code == 'TASK_MEMBER') {
            if ($("#gantt_container").length == 1) {
                refreshTask(self.params[0], true);
            } else {
                lxTaskList(self.data.gen.projectId, self.params[0]);
            }
        } else if (self.code == 'PROJECT_OFF') {
            if ($("#gantt_container").length == 1) {
                window.location.reload();//refreshProjectData(self.data.gen.projectId);
            } else {
                lxTaskList(self.data.gen.projectId);
            }
        }
    },
    submit: function (params) {
        var self = this;
        var lData = [];
        var lFormData = [];
        var lErr = false;
		//alert("pre submit");
        for (var j = 0; j < this.change.length; j++) {
            lData.push(this.change[j].join('~'));
        }
        if (self.formChange) {
            for (var i = 0; i < self.data.gen.form.item.length; i++) {
                lFormData.push( lx.item.val({ "id": "lxForm" + i, "type": self.data.gen.form.item[i].type }) );
            }
        }
        lx.load.add();
		//alert(self.code+"-"+lData.join("|"));
        apex.server.process("multirowSubmit", {
            x01: self.code,
            x02: self.page,
            x03: self.params.join(":"),
            x04: self.search,
            x05: self.searchCol,
            x06: lData.join("|"),
            x07: self.delete.join(":"),
            x08: lFormData.join("|")
        }, {
			dataType: "json",
			success: function (d) {
				apex.message.clearErrors();
				if (d.msg) {
					if (self.data.gen.open == "popUp") alert(d.msg);
					else apex.message.showErrors([{ type: "error", location: ["page"], message: d.msg, unsafe: false }]);
				}
				if (d.err) {
					if (self.data.gen.open == "popUp") alert(d.err);
					else apex.message.showErrors([{ type: "error", location: ["page"], message: d.err, unsafe: false }]);
				} else if (params) {
					self.updated = true;
					self.change = [];
					self.delete = [];
					self.formChange = false;
					self.close();
				} else {
					self.updated = true;
					self.change = [];
					self.delete = [];
					self.formChange = false;
					self.data.rows = d.rows;
					self.data.records = d.records;
					if (d.info) self.data.gen.info = d.info;
					if (d.formData) self.data.gen.formData = d.formData;
					self.open();
					if (!d.msg) {
						if (self.data.gen.open != "popUp") apex.message.showPageSuccess("Changes saved.");
					}
					if (d.retVals) {
						for (var i = 0; i < d.retVals.length; i++) {
							var val = d.retVals[i];
							$s(val.item, val.value);
						}
					}
				}
				lx.load.remove();
				self.close();
			}
        });
    }
};

lx.multirow.lxSelectBox = function (pThis) {
    var $this = $(pThis), alreadySelected = $this.hasClass("active");
    $this.parent().find(".active").removeClass("active");
    if (!alreadySelected) $this.addClass("active");
    $this.trigger("change");
}

lx.multirow.lxpItemMD = function (pThis, pOptions) {
    var vItem = $(pThis);
    var vH = vItem.find("select[name=lxpItemMD_H]").val();
    var vM = vItem.find("select[name=lxpItemMD_M]").val();
    var vMins = vH*60 + parseInt(vM);
    if (vH == ''){
        vMins = '';
        vItem.find("select[name=lxpItemMD_M]").val('');
    } else if ( vM == ''){
        vM = 0;
        vMins = vH*60 + vM;
        vItem.find("select[name=lxpItemMD_M]").val(0);
    } else if (vH == 24) {
        vM = 0;
        vMins = vH*60;
        vItem.find("select[name=lxpItemMD_M]").val(0);
    }
    vItem.find('input').val( vMins );
    
    if (multirowForm.calcDuration){
        var vRow = vItem.closest('tr');
        var vCurrentId = vItem.find('input').id;
        var vMinFrom, vMinTo;
        if (multirowForm.calcDuration.from == vCurrentId) vMinFrom = vMins;
        else vMinFrom = parseInt(vRow.find('input[name='+ multirowForm.calcDuration.from +']').val());
        if (multirowForm.calcDuration.to == vCurrentId) vMinTo = vMins;
        else vMinTo = parseInt(vRow.find('input[name='+ multirowForm.calcDuration.to +']').val());
        if ( !isNaN(vMinFrom) && !isNaN(vMinTo) ){
            var vDuration = 0;
            if (vMinFrom < vMinTo){
                vDuration = vMinTo - vMinFrom;
            }
            var vHrs = Math.floor(vDuration / 60);
            var vMin = vDuration % 60;
            vRow.find('select[name='+ multirowForm.calcDuration.hrs +']').val(vHrs);
            vRow.find('select[name='+ multirowForm.calcDuration.min +']').val(vMin);
            //console.log('Hours/Minuts changed!'+ vHrs);
        }
    }
}

var multirowForm = lx.multirow;
var lxSelectBox = lx.multirow.lxSelectBox;
var lxpItemMD = lx.multirow.lxpItemMD;
